
import Vue from "vue";
import API from "../service/config";
import { post, fetch, patch, put, toDelete } from "../service/http-service";
import { Loading } from "element-ui";

export default Vue.extend({
  name: "Visualization",
  props: {
    params: {
      type: Object,
      default: function () {
        return {
          cellType: [],
        };
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      keyword: "",
      loading: false,
      tableData: [] as any,
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      
      exploreData: [],
      explore: [],
      keyValue: "",
      ppoverValue: false,
      keywordbycelltype: "",
      zNodes: [],
      cellStrictly: false,
    };
  },
  async created() {
    if (this.$route.query.search) {
      let searchStr: any = this.$route.query.search;
      this.keyword = searchStr;
    }
    const nodes = await this.celltypeChange();
    this.zNodes = nodes;
    this.setCellDisabled(this.zNodes[0]);
  },
  mounted() {
    this.getType();
    this.getDataList();
  },
  watch: {
    keywordbycelltype(val) {
      if (val) {
        console.log("val:"+val);
        (this.$refs.tree as any).filter(val);
      }
    }},
  methods: {
    //获取列表数据
    getDataList() {
      let loadingInstance = Loading.service({});
      let postData: any = {
        index: this.pageIndex,
        size: this.pageSize,
        value: this.keyword,
        tableType: this.keyValue,
        visualization: null,
        species: null,
        diseases: null,
        tissueType: null,
        libraryProtocol: null,
        cellType: null,
        datasetId: null,
        type: "id",
        isasc: true,
        visitTable: false,
      };
      postData[this.keyValue] = this.explore;
      post(API.domainUrl + API.getMetadata, postData).then((response: any) => {
        if (response.status.code == 200) {
          loadingInstance.close();
          this.tableData = response.data.records;
          this.total = response.data.total;
        } else {
          loadingInstance.close();
          this.$message.error(response.status.msg);
        }
      });
    },
    getType() {
      fetch(API.domainUrl + API.getType).then((response: any) => {
        if (response.status.code == 200) {
          this.exploreData = response.data;
        } else {
          this.$message.error(response.status.msg);
        }
      });
    },
    async celltypeChange() {
      const node = await this.$store.dispatch("cellCollection/fetchCelltree");
      return node;
    },
    setCellDisabled(node: any, parentNode: any = null): void {
      if (node.type === 0 && node.label !== "Cell") {
        const children = parentNode ? parentNode.children : [];
        if (parentNode) {
          parentNode.children = children.filter((d: any) => d.id !== node.id);
        }
      }
      if (node.children) {
        node.children.forEach((item: any) => {
          this.setCellDisabled(item, node);
        });
      }
    },
    filterNode(value: boolean, data: any) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    checkChange() {
      const checkedNodes = (this.$refs.tree as any).getCheckedNodes();
      this.params.cellType = Array.from(
        new Set(checkedNodes.map((e: any) => e.label))
      );
      this.explore = this.params.cellType;
      this.$forceUpdate();
    },
    //点击分页
    handleCurrentChange(val: number) {
      this.pageIndex = val;
      this.getDataList();
    },
    handleSizeChange(val: number) {
      this.pageIndex = 1;
      this.pageSize = val;
      this.getDataList();
    },
    //search 搜索
    searchFun() {
      this.pageIndex = 1;
      this.getDataList();
    },
    //点击按钮搜索
    btnSearch() {
      let loadingInstance = Loading.service({});
      post(API.domainUrl + API.metadataSearch, {}).then((response: any) => {
        if (response.status.code == 200) {
          loadingInstance.close();
        } else {
          loadingInstance.close();
          this.$message.error(response.status.msg);
        }
      });
    },
    searchData(key: any) {
      this.keyValue = key;
      this.pageIndex = 1;
      this.pageSize = 10;
      this.getDataList();
    },
    showPopover(key: any) {
      if (this.keyValue != key) {
        if(key != 'cellType'){
          this.ppoverValue = false;
        }else{
          this.ppoverValue = !this.ppoverValue;

        }
        
      }
    },
    showDetail(url: string, data: any) {
      sessionStorage.setItem("setDetailData", JSON.stringify(data));
      this.$store.commit("setDetailData", data);
      this.$router.push({ path: url });
    },
  },
});
